import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function SolutionSection() {
  return <section className="py-24 px-4 bg-burgundy-900 text-cream-100 relative overflow-hidden" data-id="element-197">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] pointer-events-none" data-id="element-198" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-199">
        <FadeIn data-id="element-200">
          <div className="text-center mb-16" data-id="element-201">
            <span className="text-gold-400 tracking-widest text-sm font-semibold uppercase mb-4 block" data-id="element-202">
              La Revelación
            </span>
            <h2 className="text-3xl md:text-5xl font-serif mb-6 text-white" data-id="element-203">
              No necesitas "más pasión".
              <br data-id="element-204" />
              Necesitas{' '}
              <span className="text-gold-400 italic" data-id="element-205">menos exposición</span>.
            </h2>
            <p className="text-xl text-cream-200 max-w-2xl mx-auto" data-id="element-206">
              Por eso funciona este método: elimina el riesgo de sentirte
              rechazado/a.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-207">
          <FadeIn delay={200} className="bg-burgundy-800/50 p-8 rounded-3xl border border-burgundy-700 backdrop-blur-sm" data-id="element-208">
            <div className="w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center text-burgundy-900 font-bold text-xl mb-6" data-id="element-209">
              1
            </div>
            <h3 className="text-2xl font-serif text-gold-100 mb-4" data-id="element-210">
              Micro-Inicios (5 min)
            </h3>
            <p className="text-cream-200 leading-relaxed" data-id="element-211">
              Acercamientos diseñados para durar solo 5 minutos. Son tan
              pequeños que no activan la "alarma de pena" ni las defensas de tu
              pareja. Es volver a tocarse sin la presión de que "tenga que pasar
              algo más".
            </p>
          </FadeIn>

          <FadeIn delay={400} className="bg-burgundy-800/50 p-8 rounded-3xl border border-burgundy-700 backdrop-blur-sm" data-id="element-212">
            <div className="w-12 h-12 bg-gold-500 rounded-full flex items-center justify-center text-burgundy-900 font-bold text-xl mb-6" data-id="element-213">
              2
            </div>
            <h3 className="text-2xl font-serif text-gold-100 mb-4" data-id="element-214">
              Semáforo de Comodidad
            </h3>
            <p className="text-cream-200 leading-relaxed" data-id="element-215">
              Un sistema simple (Verde/Amarillo/Rojo) para comunicar
              disponibilidad sin palabras hirientes. Sabrás exactamente cuándo
              avanzar y cuándo esperar, eliminando por completo el miedo a "leer
              mal las señales".
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={600} className="mt-16 text-center" data-id="element-216">
          <div className="inline-block p-6 border-t border-b border-burgundy-700" data-id="element-217">
            <p className="text-2xl font-serif italic text-gold-300" data-id="element-218">
              "Deja de ser adivinar. Deja de ser un examen."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}